import React, { useState, useEffect, useRef, useCallback } from "react";

const getBracket = (width) => {
	if (width < 480) return 0;
	if (width < 640) return 1;
	if (width < 1024) return 2;
	if (width < 1280) return 3;
	if (width < 1440) return 4;
	if (width < 1920) return 5;
	return 6;
};

export default function Image({ src, width, height }) {
	const [loaded, setLoaded] = useState(false);
	const [bracket, setBracket] = useState(0);
	const boxRef = useRef(null);
	const imageRef = useRef(null);

	const updateBracket = useCallback(() => {
		let elWidth = 0;
		if (boxRef.current) {
			elWidth = boxRef.current.clientWidth * window.devicePixelRatio;
		}
		if (elWidth === 0) {
			elWidth = window.innerWidth * window.devicePixelRatio
		}
		const newBracket = getBracket(elWidth);
		setBracket((prev) => (prev !== newBracket ? newBracket : prev));
	}, []);

	useEffect(() => {
		updateBracket();
		window.addEventListener("resize", updateBracket);
		return () => window.removeEventListener("resize", updateBracket);
	}, [updateBracket]);

	useEffect(() => {
		if (imageRef.current?.complete) {
			setLoaded(true);
		}
	}, [src]);

	if (!src) return null;

	const imgSrc = src[bracket];
	const wrapperClass = `c-media ${!width || !height ? "c-media--fill" : ""} ${loaded ? "state-media-loaded" : ""}`;
	const style = width && height ? { paddingTop: `${(height / width) * 100}%` } : undefined;

	return (
		<div className={wrapperClass} ref={boxRef} style={style}>
			<img ref={imageRef} onLoad={() => setLoaded(true)} alt="" src={imgSrc} />
		</div>
	);
}